import React from 'react';
import { first } from 'lodash';
import { BasicForm } from './BasicForm.jsx';
import { FormLabel } from '../FormLabel.jsx';
import { FormErrorMessage } from '../FormErrorMessage.jsx';
import { getUUID } from '../../../../../../utils/getUUID.js';

export class FileForm extends BasicForm {
  constructor (props) {
    super(props);
    this.state = {
      selectedFile: undefined,
      isFileSizeExceeded: false,
      isUploading: false
    };
    this.uniqId = getUUID()
  }

  handleFileChange (e) {
    const files = e.target.files;
    const file = first(files);
    if (!file) return;
    if (file.size > 25000000) {
      this.setState({ selectedFile: undefined, isFileSizeExceeded: true });
      this.resetInput();
    } else {
      this.setState({ isUploading: true });
      // TODO: Refactor this
      window.uploadFileToS3({
        url: window.s3UploadUrl,
        s3FormData: window.s3FormData,
        file: file
      }).then(({ decodedUrl }) => {
        this.setState({ selectedFile: file, isFileSizeExceeded: false, isUploading: false });
        this.props.input.onChange(decodedUrl);
      }).catch(() => {
        this.setState({ selectedFile: undefined, isFileSizeExceeded: false, isUploading: false });
      });
    }
  }

  clearFile = () => {
    this.setState({ selectedFile: undefined, isFileSizeExceeded: false });
    this.resetInput();
  }

  resetInput = () => {
    const input = document.getElementById(this.uniqId);
    this.props.input.onChange('');
    if (input) input.value = '';
  }

  render () {
    const { input, object, meta, disabled } = this.props;
    const hasValue = !!input.value;
    const accepts = object.validations.file_types.join(',');

    return (
      <div className="cu-ui-form-group">
        <FormLabel
          valid={meta.valid}
          label={object.label}
          required={object.validations.required}
        />
        <div className="cu-ui-input-container cu-ui-file-form">
          <input
            type="text"
            className="cu-ui-file-form__name"
            readOnly={true}
            value={hasValue && this.state.selectedFile?.name || ''}
            placeholder="ファイルを選択する"
            disabled={disabled}
          />
          <input
            type="file"
            accept={accepts}
            onChange={this.handleFileChange.bind(this)}
            disabled={disabled}
            name={object.id}
            id={this.uniqId}
          />
          <label
            className="cu-ui-file-form__select"
            for={this.uniqId}
            disabled={hasValue && (disabled || this.state.selectedFile || this.state.isUploading)}
            tabIndex="0"
          >
            参照
          </label>
          <label
            className="cu-ui-file-form__reset"
            onClick={this.clearFile}
            disabled={!hasValue || disabled || !this.state.selectedFile}
            tabIndex="0"
          >
            削除
          </label>
        </div>
        <FormErrorMessage
          error={this.state.isFileSizeExceeded ? ['画像サイズは25MB以下にしてください'] : meta.error}
          touched={this.state.isFileSizeExceeded ? true : meta.touched}
        />
      </div>
    );
  }
}
